var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-price.j2"] = require( "macros/product-price.j2" );
dependencies["macros/price-promo-labels.j2"] = require( "macros/price-promo-labels.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-mto-product-tile-price.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-price.j2", false, "core/templates/core-mto-product-tile-price.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayPriceValue")) {
var t_4 = t_1.displayPriceValue;
} else {
cb(new Error("cannot import 'displayPriceValue'")); return;
}
context.setVariable("displayPriceValue", t_4);
output += "\n";
env.getTemplate("macros/price-promo-labels.j2", false, "core/templates/core-mto-product-tile-price.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("displayPromoLabels")) {
var t_8 = t_5.displayPromoLabels;
} else {
cb(new Error("cannot import 'displayPromoLabels'")); return;
}
context.setVariable("displayPromoLabels", t_8);
output += "\n\n";
var t_9;
t_9 = (lineno = 3, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["tile.skuInfo.salePriceLow",runtime.contextOrFrameLookup(context, frame, "None")]));
frame.set("salePrice", t_9, true);
if(frame.topLevel) {
context.setVariable("salePrice", t_9);
}
if(frame.topLevel) {
context.addExport("salePrice", t_9);
}
output += "\n";
var t_10;
t_10 = (lineno = 4, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["tile.skuInfo.listPriceLow",runtime.contextOrFrameLookup(context, frame, "None")]));
frame.set("listPrice", t_10, true);
if(frame.topLevel) {
context.setVariable("listPrice", t_10);
}
if(frame.topLevel) {
context.addExport("listPrice", t_10);
}
output += "\n";
var t_11;
t_11 = (runtime.contextOrFrameLookup(context, frame, "salePrice") && runtime.contextOrFrameLookup(context, frame, "salePrice") != runtime.contextOrFrameLookup(context, frame, "listPrice")?runtime.contextOrFrameLookup(context, frame, "salePrice"):runtime.contextOrFrameLookup(context, frame, "listPrice"));
frame.set("currentPrice", t_11, true);
if(frame.topLevel) {
context.setVariable("currentPrice", t_11);
}
if(frame.topLevel) {
context.addExport("currentPrice", t_11);
}
output += "\n\n<div class=\"c-product-tile__price c-product-tile__price--";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tileTemplate"), env.opts.autoescape);
output += "\">\n\t";
if(runtime.contextOrFrameLookup(context, frame, "currentPrice")) {
output += "\n\t\t<span class=\"c-product-meta__current-price\" data-qa-current-price>\n\t\t\t";
output += runtime.suppressValue((lineno = 10, colno = 5, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["mto-product_tile-starting-at"])), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue((lineno = 10, colno = 58, runtime.callWrap(t_4, "displayPriceValue", context, [runtime.contextOrFrameLookup(context, frame, "currentPrice"),runtime.contextOrFrameLookup(context, frame, "core")])), env.opts.autoescape);
output += "\n\t\t</span>\n\t";
;
}
output += "\n\n\t";
output += "\n\t";
if(runtime.contextOrFrameLookup(context, frame, "productInfo") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productInfo")),"promotionLabels")) {
output += "\n\n\t    ";
var t_12;
t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productInfo")),"promotionLabels");
frame.set("promos", t_12, true);
if(frame.topLevel) {
context.setVariable("promos", t_12);
}
if(frame.topLevel) {
context.addExport("promos", t_12);
}
output += "\n\n\t    ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "promos")) > 0) {
output += "\n\n\t        <p class=\"s-mto-product-tile\">\n\t        \t";
output += runtime.suppressValue((lineno = 22, colno = 29, runtime.callWrap(t_8, "displayPromoLabels", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "promos")])), env.opts.autoescape);
output += "\n\t        </p>\n\n\t    ";
;
}
output += "\n\n\t";
;
}
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-mto-product-tile-price.j2"] , dependencies)